
<template lang="pug">
  .mr-input(:class="{ 'raise-label': raiseLabel }")
    input(
      :id="inputId"
      :type="inputType"
      :value="value"
      :data-mr-ass="dataMrAss"
      @input="update($event.target.value)"
      @focus="checkInput($event.type)"
      @blur="checkInput($event.type)"
      :class="{ 'invalid': v.$error }"
      :autocomplete="autocomplete"
      :disabled="disabled"
      :name="name"
      ref="inputEl"
    )
    label(:for="inputId") {{ label }}

    TransitionExpand
      .input-error.xs-f-xsmall.lg-f-xxsmall.max-at-tweak(v-if="inputError")
        i.icon-warning
        | {{ inputError }}

</template>

<script>
  import TransitionExpand from './TransitionExpand';

  export default {
    name: "mrInput",
    components: {
      TransitionExpand
    },
    props: {
      name: {
        type: String,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      label: {
        type: String,
        required: true
      },
      inputType: {
        type: String,
        default: "text"
      },
      autocomplete: {
        type: String,
        required: false
      },
      value: {
        type: [String, Boolean]
      },
      focusOnMount: {
        type: Boolean,
        default: false
      },
      dataMrAss: {
        type: String
      },
      v: { 
        type: Object,
        default: () => ({})
      },
    },

    data() {
      return {
        raiseLabel: false,
        validateTimeout: 0,
        inputId: 'mrInput_' + Math.random()*Math.pow(10, 17),
      }
    },

    computed: {
      text: {
        get(){
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        }
      },

      inputError: function() {
        var error = null;
        if (!this.v.$params) {
          return error;
        }

        if (this.v.$params.minLength && !this.v.minLength && this.v.$error) {
          error = `Must be at least ${this.v.$params.minLength.min} characters.`;
        } else if (this.v.$params.maxLength && !this.v.maxLength && this.v.$error) {
          error = `Must be less than ${this.v.$params.maxLength.max + 1} characters.`;
        } else if (this.v.$params.email && !this.v.email && this.v.$error) {
          error = `Must be a valid email.`;
        } else if (this.v.$params.hasOwnProperty('mrPhoneValidator') && !this.v.mrPhoneValidator && this.v.$error) {
          error = `Please enter a valid 10-digit phone number.`;
        } else if (this.v.$params.hasOwnProperty('passwordSameAs') && !this.v.passwordSameAs) {
          error = `Passwords do not match`;
        } else if (this.v.$params.hasOwnProperty('mrCardValidator') && !this.v.mrCardValidator && this.v.$error) {
          error = `Please enter valid credit card`;
        } else if (this.v.$params.required && this.v.$error) {
          error = `This field is required.`;
        }

        return error;
      }
    },

    mounted() {
      this.checkInput();
      if (this.focusOnMount) {
        this.$refs.inputEl.focus();
      }
    },

    updated() {
      this.checkInput();
    },

    methods: {
      update(val) {
        this.delayTouch(this.v);
        this.$emit('input', val);
      },

      checkInput(type) {
        if (type == 'focus') {
          return this.raiseLabel = true;
        }

        this.raiseLabel = this.text && this.value.length ? true : false;
      },

      delayTouch($v) {
        if (!$v.$params) {
          return;
        }

        $v.$reset();
        clearTimeout(this.validateTimeout);
        this.validateTimeout = setTimeout(() => {
          $v.$touch();
        }, 800);
      }

    }
  }
</script>

<style scoped lang="stylus">
  .mr-input
    position relative
    display block
    margin 0.55em 0

    label
      position absolute
      top 12px
      left 1.1em
      z-index 1
      cursor text
      pointer-events none
      color #999
      font-size 14px
      line-height 1.3em

    input
      border-radius 4px
      transition(border-color 0.6s)

      &.invalid
        border 2px solid color-attention

      &:focus
        border 2px solid color-mr-blue


    .customDropdown
      .option.expanded
        z-index 2

    &.raise-label
      label
        top 5px
        font-size 10px

      input
      .select
        padding-top 15px
        padding-bottom 5px

  .input-error
    color color-attention
</style>
